/**
 * Profile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const UserRoleDto = {
    User: 'USER',
    Analyst: 'ANALYST',
    Admin: 'ADMIN',
    System: 'SYSTEM',
    SysAdmin: 'SYS_ADMIN'
} as const;
export type UserRoleDto = typeof UserRoleDto[keyof typeof UserRoleDto];

